import { IntegrityMonitorDirectoryRuleFormWebComponent } from './component/IntegrityMonitorDirectoryRuleFormWebComponent';
import { WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_DIRECTORY_FORM } from '../../../../webcomponents.constants';

export { IntegrityMonitorDirectoryRuleFormWebComponent };

window.customElements.define(
  WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_DIRECTORY_FORM,
  IntegrityMonitorDirectoryRuleFormWebComponent
);
